import React, { FC } from "react";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import useGlobalModel from "@/model/globalModel";
import { RouterParamType } from "@/model/navModel";
import { useVrmNewMaintenanceDetailsModel } from "../vrmNewBillmaintenanceModel";
import { repairFormatNum } from "@/utils/utils";
export const FixedBottom: FC<RouterParamType> = ({ id, mode }) => {
    const { cm } = useGlobalModel();
    const { lookDesc } = useVrmNewMaintenanceDetailsModel()
    const orderStatistics: IDescription[] = [
        {
            label: "工时小计",
            value: `${repairFormatNum(lookDesc.workHoursPrice)} (${lookDesc.workHoursNum})项`,
            color: DescriptionColorEnum.red,
            status: true
        },
        {
            label: "配件小计",
            value: `${repairFormatNum(lookDesc.partPrice)} (${lookDesc.partPriceNum})项`,
            color: DescriptionColorEnum.red,
            status: true
        },
        {
            label: "费用合计",
            value: repairFormatNum(lookDesc.partPrice + lookDesc.workHoursPrice),
            color: DescriptionColorEnum.red,
            status: true
        },
        {
            label: "优惠金额",
            value: repairFormatNum(lookDesc.discountAll),
            color: DescriptionColorEnum.red,
            status: true
        },
        {
            label: "应收金额",
            value: repairFormatNum(lookDesc.receivableAll),
            color: DescriptionColorEnum.red,
            status: true
        }
    ]
    return (
        <div className="details-bot-fixed-warp" style={{ width: `calc(100% - ${cm.collapsed ? '80px' : '226px'})`, paddingLeft: "43px" }}>
            {orderStatistics.map((item, index) => <Description key={index} {...item} />)}
        </div>
    )
}